import React, { HTMLAttributes } from 'react';
import { Profile } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import EntitiesHighlighted from '../../../components/EntitiesHighlighted';
import { ParagraphPersonsSelected as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphPersonsSelectedProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphPersonsSelected: React.FC<ParagraphPersonsSelectedProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const experts = paragraph.field_experts;
  const linkTitle = paragraph.field_link[0]?.title;
  const linkUri = paragraph.field_link[0]?.alias || paragraph.field_link[0]?.uri;

  return (
    <div className="Paragraph ParagraphPersonsSelected">
      <EntitiesHighlighted
        title={title}
        body={body}
        link={linkUri}
        linkTitle={linkTitle}
        linkPosition="left"
        wide={false}
      >
        <div className="row ParagraphPersonsSelected__items">
          {experts.map((expert) => {
            const id = expert.target_id;
            const uuid = expert.target_uuid;
            const key = `${uuid}`;

            return (
              <div className="col-12" key={key}>
                <Profile
                  key={key}
                  id={id}
                  viewMode="teaser"
                  classes="inline"
                />
              </div>
            );
          })}
        </div>
      </EntitiesHighlighted>
    </div>
  );
};

export default ParagraphPersonsSelected;
